// extracted by css-extract-rspack-plugin
export default {"root":"root-B1bYvA","headline":"headline-yS3Q5k","video":"video-T3XLcF","action":"action-tsJTsO"};